import React from 'react';

import { Icon } from 'components/ApplicationIcon/styles';

interface FrameworkIconProps {
  badge: { icon: string; label: string };
  size: number;
  disable?: boolean;
  ratio?: number;
}

const BADGE_RATIO = 0.6;
const BADGE_OFFSET_RATIO = 0.25;

const FrameworkIcon = ({
  badge,
  size,
  disable,
  ratio = BADGE_RATIO,
}: FrameworkIconProps) => {
  const badgeSize = size * ratio;
  const badgeOffset = -badgeSize * BADGE_OFFSET_RATIO;

  return (
    <Icon
      width={`${badgeSize}px`}
      height={`${badgeSize}px`}
      icon={badge.icon}
      disable={disable}
      title={badge.label}
      style={{
        position: 'absolute',
        left: `${badgeOffset}px`,
        bottom: `${badgeOffset}px`,
        padding: '2px',
        boxSizing: 'border-box',
        background: '#fff',
        borderRadius: '50%',
        boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.08)',
      }}
    />
  );
};

export default FrameworkIcon;
